import React from 'react';
import './shipment-action-button.css';

export default function ShipmentActionButton({ children = 'Düzenle', variant = 'edit', className = '', ...props }) {
  return <button type="button" {...props} className={`cimento-action-button cimento-action-button--${variant} ${className}`.trim()}>
    <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {variant === 'continue' ? <path d="M4 12h15m-6-6 6 6-6 6" /> : variant === 'history' ? <><path d="M3 11a9 9 0 1 1 2 7M3 5v6h6" /><path d="M12 7v5l3 2" /></> : <path d="m15 5 4 4M4 20l4-1 12-12a2.8 2.8 0 0 0-4-4L4 15l-1 6Z" />}
    </svg>
    <span>{children}</span>
  </button>;
}
